import { Plus, Users } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { mockGroups, mockUsers } from './mockData';

const GroupManagementTab = () => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <p className="text-sm text-muted-foreground">{mockGroups.length} Gruppen angelegt</p>
        <Button size="sm" variant="outline" className="gap-2">
          <Plus className="h-4 w-4" />
          Neue Gruppe
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {mockGroups.map((group) => {
          const members = mockUsers.filter((u) => u.groupId === group.id);
          const leader = members.find((u) => u.id === group.leaderId);

          return (
            <Card key={group.id} className="border-border/50 bg-card/80 backdrop-blur-xl">
              <CardHeader className="pb-3">
                <div className="flex items-center gap-3">
                  <div className="h-4 w-4 rounded-full shrink-0" style={{ backgroundColor: group.color }} />
                  <CardTitle className="text-base">{group.name}</CardTitle>
                </div>
              </CardHeader>
              <CardContent>
                <div className="flex items-center gap-2 text-sm text-muted-foreground mb-3">
                  <Users className="h-4 w-4" />
                  <span>{members.length} Mitglieder</span>
                  {leader && (
                    <>
                      <span className="text-border">·</span>
                      <span>Leitung: {leader.name}</span>
                    </>
                  )}
                </div>
                <div className="flex flex-wrap gap-1.5">
                  {members.map((m) => (
                    <span
                      key={m.id}
                      className="inline-flex items-center rounded-full bg-secondary px-2.5 py-0.5 text-xs font-medium"
                    >
                      {m.name.split(' ').pop()}
                    </span>
                  ))}
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      {/* Unassigned users */}
      {mockUsers.filter((u) => !u.groupId).length > 0 && (
        <Card className="border-dashed border-border/50">
          <CardHeader className="pb-3">
            <CardTitle className="text-base text-muted-foreground">Ohne Gruppe</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="flex flex-wrap gap-1.5">
              {mockUsers
                .filter((u) => !u.groupId)
                .map((m) => (
                  <span
                    key={m.id}
                    className="inline-flex items-center rounded-full bg-muted px-2.5 py-0.5 text-xs font-medium"
                  >
                    {m.name}
                  </span>
                ))}
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default GroupManagementTab;
